<template>
  <div class="card">
    <div class="controls-wrap">
      <div class="user-controls d-none d-sm-block">
        <!-- <h5 style="font-weight: 700">Users & Logs</h5> -->
        <div class="d-flex align-items-start">
          <nav class="job-controls-tabs w-100">
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
              <a
                class="nav-item nav-link active"
                id="nav-users-tab"
                data-toggle="tab"
                href="#nav-users"
                role="tab"
                aria-controls="nav-users"
                aria-selected="true"
                >USERS</a
              >
              <a
                class="nav-item nav-link"
                id="nav-logs-tab"
                data-toggle="tab"
                href="#nav-logs"
                role="tab"
                aria-controls="nav-logs"
                aria-selected="false"
                >LOGS</a
              >
            </div>
          </nav>

          <AddBtn data-bs-toggle="modal" data-bs-target="#addUserModal" class="ml-auto mt-3 mr-3"
            >Add User</AddBtn
          >
        </div>
      </div>

      <div class="tab-content m-0" id="nav-tabContent-users">
        <section
          class="tab-pane fade show active"
          id="nav-users"
          role="tabpanel"
          aria-labelledby="nav-users-tab"
        >
          <div class="scroller">
            <table class="table table-striped custom-table">
              <thead class="bg-dark">
                <tr>
                  <th nowrap scope="col">NAME</th>
                  <th nowrap scope="col">EMAIL</th>
                  <th nowrap scope="col">PHONE</th>
                  <th nowrap scope="col">NOTIFICATIONS</th>
                  <th nowrap scope="col">DATE FORMAT</th>
                  <th nowrap scope="col">Time zone</th>
                  <th nowrap scope="col">ROLE</th>
                  <th nowrap scope="col">User Conditions</th>
                  <th nowrap scope="col" style="text-align:right; padding-right:25px">ACTIONS</th>
                  <th nowrap scope="col" style="text-align: center">PASSWORD</th>
                </tr>
              </thead>

              <tbody>
                <UsersTableItem
                  v-for="user in getEmployerUsers"
                  :key="user.id"
                  :user="user"
                  @application-reload="reloadApplications"
                  @change="reloadApplications"
                />
              </tbody>
            </table>
          </div>
        </section>

        <section class="tab-pane fade" id="nav-logs" role="tabpanel" aria-labelledby="nav-logs-tab">
          <div class="jobs-controls">
            <div class="d-flex" style="margin: -20px 0 12px -5px">
              <select
                @change="handleNames($event)"
                v-model="searchWord"
                class="form-control form-control w-25 ml-3"
              >
                <option value>All users</option>
                <option
                  :value="`${user.first_name} ${user.last_name}`"
                  v-for="user in getEmployerUsers"
                >
                  {{ user.first_name }} {{ user.last_name }}</option
                >
              </select>
              <select
                class="form-control ml-2 w-25"
                v-model="action"
                @change="handleActions($event)"
              >
                <option value>Actions</option>
                <option v-for="action in getLogActions" :key="action.id" :value="action.id">
                  {{ action.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="scroller">
            <table class="table table-striped custom-table">
              <thead class="bg-dark">
                <tr>
                  <th nowrap scope="col">User</th>
                  <th nowrap scope="col">Email</th>
                  <th nowrap scope="col">Date</th>
                  <th nowrap scope="col">IP</th>
                  <th nowrap scope="col">Location</th>
                  <th nowrap scope="col">Platform</th>
                  <th nowrap scope="col">Device</th>
                  <th nowrap scope="col">Browser</th>
                  <th nowrap scope="col">Action</th>
                  <th nowrap scope="col">Text</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="log in getLogs" :key="log.id">
                  <td nowrap>{{ log.user_name }}</td>
                  <td nowrap>
                    <div class="text-truncate">{{ log.user_email }}</div>
                  </td>
                  <td nowrap>
                    {{
                      log.date
                        | formatDate({
                          format: getUserProfile.format_date,
                          timezone: getUserProfile.timezone,
                          hasHourAndMinutes: true,
                        })
                    }}
                  </td>
                  <td>{{ log.ip_address }}</td>
                  <td>{{ handleLocation(log.location) }}</td>
                  <td>{{ log.platform }}</td>
                  <td>{{ log.device }}</td>
                  <td>{{ log.browser }}</td>
                  <td>{{ log.action_name }}</td>
                  <td>{{ log.related_record_name }}</td>
                </tr>
              </tbody>
            </table>

            <ErrorList
              v-if="[...getEmployerLogs.data].length === 0"
              class="no-data-message"
              name="noEmployerLogs"
            />
          </div>
          <span class="bottom-controls d-flex ml-auto w-10">
            <div id="pagination" class="desktop-only ml-auto" tabindex="0">
              <!-- Pagination -->
              <Pagination
                :currentPage="currentPage"
                :totalPages="totalPages"
                @nextPage="nextPage"
                @prevPage="previousPage"
                @selectPageByNumber="setPageBynumber"
                @firstPage="setToFirstPage"
                @lastPage="setToLastPage"
                @keyup="keymonitor"
              ></Pagination>
            </div>
          </span>
        </section>
      </div>
    </div>

    <!-- Add User Modal -->
    <div
      class="modal fade edit-modal"
      id="addUserModal"
      tabindex="-1"
      aria-labelledby="addUserModal"
      aria-hidden="true"
      role="dialog"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addUserModalLabel">Add User</h5>
            <button
              type="button"
              class="close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="onCloseAddUserModal"
              ref="closeAddUser"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="d-flex mt-3">
              <div class="form-group flex-grow-1">
                <div class="form-group m-label-left">
                  <input v-model="firstName" type="text" id="first-name" class="form-control" />
                  <label for="name">First Name</label>
                </div>
                <div class="form-group m-label-left">
                  <input v-model="lastName" type="text" id="last-name" class="form-control" />
                  <label for="name">Last Name</label>
                </div>
                <div class="form-group m-label-left">
                  <input v-model="email" type="text" id="email" class="form-control" />
                  <label for="email">Email</label>
                </div>
                <div class="row">
                  <div class="form-group m-label col-md-5 country-code-user no-hor">
                    <v-select
                      id="country-code"
                      style="font-size: 14px; height: 42px"
                      @input="addCountryCodeEdit(countryCode)"
                      v-model="countryCode"
                      :options="[...getAllCountries].map(item => `${item.phone_code} ${item.name}`)"
                      :clearable="false"
                    >
                      <template v-slot:option="option">
                        {{ option.label }}
                      </template>
                    </v-select>
                    <label for="country-code">Country Code</label>
                  </div>
                  <div class="form-group m-label col-md-7">
                    <input v-model="phone" type="text" id="phone" class="form-control" />
                    <label for="phone">Phone</label>
                  </div>
                </div>

                <div class="form-group m-label-left isWidth">
                  <select v-model="notifications" id="user-type" class="form-control mt-2">
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                  <label for="user-type">Email Notifications</label>
                </div>
                <div class="form-group m-label-left">
                  <select v-model="selectedDateFormat" id="format_date" class="form-control mt-2">
                    <option>YY-MM-DD</option>
                    <option>YY/MM/DD</option>
                    <option>DD-MM-YY</option>
                    <option>DD/MM/YY</option>
                    <option>MM-DD-YY</option>
                    <option>MM/DD/YY</option>
                  </select>
                  <label for="name">Date Format</label>
                </div>

                <div class="form-group m-label-left country-code-user">
                  <v-select
                    ref="tzSelect"
                    placeholder="Select Timezone"
                    v-model="timeZone"
                    :options="tzOptions"
                    :clearable="false"
                    :reduce="zone => zone"
                    :filterable="false"
                    label="utc_timezone"
                    @search="onTzSearch"
                    @open="onTzOpen"
                  >
                    <template #option="{ utc_timezone }">
                      {{ utc_timezone }}
                    </template>
                    <template #selected-option="{ utc_timezone }">
                      {{ utc_timezone }}
                    </template>
                  </v-select>
                  <label for="role">Time Zone</label>
                </div>

                <div class="form-group m-label-left">
                  <select v-model="role" id="role" class="form-control">
                    <option value="2">Manager</option>
                    <option value="1">User</option>
                  </select>
                  <label for="role">Role</label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button type="button" @click="addUser" class="btn btn-primary">Add user</button>

            <button
              @click="onCloseAddUserModal"
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- End Add User Modal -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import UsersTableItem from './UsersTableItem.vue';
import AddBtn from '../common/TableControlsAddBtn';
import { accountTypeMixin } from '../../../mixins/accountTypeMixin';
import Pagination from '../../Navigations/Pagination.vue';
import ErrorList from '@/components/common/errorsList';
import axios from 'axios';

export default {
  components: { AddBtn, UsersTableItem, ErrorList, Pagination },
  mixins: [accountTypeMixin],
  data: () => ({
    firstName: '',
    lastName: '',
    email: '',
    countryCode: '',
    phone: '',
    selectedDateFormat: 'YY-MM-DD',
    selectedUserRole: 1,
    notifications: true,
    role: 1,
    timeZone: '',
    tzOptions: [],
    tzPage: 1,
    tzLastPage: 1,
    tzSearch: '',
    tzLoading: false,
    tzSearchTimeout: null,
    users: [],
    icons: {
      crownIconSelected: 'crown-icon-selected',
      crownIcon: 'fas fa-crown ',
    },
    isSelectedDefault: false,
    itemId: '',
    picked: '',
    selected: [],
    action: '',
    searchWord: '',
    currentPage: 1,
    pageCount: 10,
    totalPages: 0,
  }),
  methods: {
    ...mapActions([
      'retrieveLogs',
      'retrieveEmployerUsers',
      'retrieveEmployerLogs',
      'retrieveLogActions',
      'retrieveUserProfile',
    ]),
    addCountryCodeEdit(code) {
      this.countryCode = code.replace(/[0-9+]/g, '');
      this.phone = code.substring(0, code.indexOf(' ')) + ' ';
    },
    onCloseAddUserModal() {
      this.firstName = '';
      this.lastName = '';
      this.email = '';
      this.phone = '';
      this.countryCode = '';
      this.timeZone = this.getUserProfile.timezone_data;
      this.selectedDateFormat = this.getUserProfile.format_date;
      this.selectedUserRole = 1;
      this.role = 1;
      this.users = [];
      this.isSelectedDefault = false;
      this.notifications = true;
      this.itemId = '';
      this.picked = '';
      this.selected = [];
    },
    saveFormChanges() {
      /*   console.log('saveFormChanges'); */
      //   this.$refs.saveform.reset();
    },
    addUser() {
      this.isLoading = true;
      let notification = true;
      if (this.notifications === 'false') {
        notification = false;
      }
      axios(`${process.env.VUE_APP_API_URL}/admin/employer/createuser`, {
        method: 'post',
        data: {
          js_employer_id: this.$route.params.employer_id,
          email: this.email,
          first_name: this.firstName,
          last_name: this.lastName,
          phone_number: this.phone,
          email_notifications: notification,
          user_type: this.role,
          country_code: this.countryCode,
          format_date: this.selectedDateFormat,
          timezone_id: this.timeZone.id,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(() => {
          this.isLoading = false;
          this.$refs.closeAddUser.click();
          this.notifications = true;
          this.emailAddress = '';
          this.firstName = '';
          this.lastName = '';
          this.phone = '';
          this.role = 11;
          this.countryCode = '';
          this.timeZone = this.getUserProfile.timezone_data;
          this.selectedDateFormat = this.getUserProfile.format_date;
          this.$toasted.success('New user created', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 8000,
          });
          this.retrieveEmployerUsers({ js_employer_id: this.$route.params.employer_id });
        })
        .catch(err => {
          this.isLoading = false;
          this.$toasted.error(err.response.data.errors.email, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
    fetchTimezones(reset = false) {
      if (this.tzLoading) return;
      if (!reset && this.tzPage > this.tzLastPage) return;
      this.tzLoading = true;
      if (reset) {
        this.tzPage = 1;
        this.tzLastPage = 1;
      }
      axios(`${process.env.VUE_APP_API_URL}/common/timezone/all`, {
        method: 'post',
        data: { page: this.tzPage, count: 50, search_word: this.tzSearch },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          Accept: 'application/json',
        },
      })
        .then(res => {
          const raw = res.data.data !== undefined ? res.data.data : res.data;
          const items = Array.isArray(raw) ? raw : Object.values(raw);
          if (reset) {
            this.tzOptions = items;
          } else {
            const dropdown = this.$refs.tzSelect.$refs.dropdownMenu;
            const scrollTop = dropdown ? dropdown.scrollTop : 0;
            items.forEach(item => this.tzOptions.push(item));
            this.$nextTick(() => {
              if (dropdown) dropdown.scrollTop = scrollTop;
            });
          }
          this.tzLastPage = res.data.last_page;
          this.tzPage += 1;
        })
        .catch(() => {})
        .finally(() => {
          this.tzLoading = false;
        });
    },
    onTzSearch(search) {
      clearTimeout(this.tzSearchTimeout);
      this.tzSearchTimeout = setTimeout(() => {
        this.tzSearch = search;
        this.fetchTimezones(true);
      }, 300);
    },
    onTzOpen() {
      this.$nextTick(() => {
        const dropdown = this.$refs.tzSelect.$refs.dropdownMenu;
        if (!dropdown) return;
        dropdown.addEventListener('scroll', this.onTzScroll);
      });
    },
    onTzScroll(e) {
      const el = e.target;
      if (this.tzPage > this.tzLastPage) return;
      if (this.tzLoading) return;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 20) {
        this.fetchTimezones();
      }
    },
    reloadApplications() {
      this.retrieveEmployerUsers({ js_employer_id: this.$route.params.employer_id });
    },
    closeModal() {
      this.selectedUserForDelete = '';
    },
    setAsDefault(e) {
      if (this.itemId !== Number(e.target.id)) {
        this.itemId = Number(e.target.id);
        this.isSelectedDefault = false;
      }

      this.isSelectedDefault = true;
    },
    handleLocation(location) {
      const list = [];

      if (location) {
        const res = location.split(',');

        res.forEach(el => {
          if (el != '') {
            list.push(el);
          }
        });

        return list.join(', ');
      } else {
        return 'N/A';
      }
    },
    handleNames(e) {
      this.currentPage = 1;
      this.retrieveLogs({
        page: this.currentPage,
        count: 10,
        record_filter: 'all_records',
        action_filter: this.action,
        search_word: this.searchWord,
        js_employer_id: this.$route.params.employer_id,
      })
        .then(res => {
          this.isLoading = false;
          this.totalPages = res.data.last_page;
        })
        .catch(err => {
          this.isLoading = false;

          new Error(err);
        });
    },
    handleActions(e) {
      this.currentPage = 1;
      this.retrieveLogs({
        page: this.currentPage,
        count: 10,
        record_filter: 'all_records',
        action_filter: this.action,
        search_word: this.searchWord,
        js_employer_id: this.$route.params.employer_id,
      })
        .then(res => {
          this.isLoading = false;
          this.totalPages = res.data.last_page;
        })
        .catch(err => {
          this.isLoading = false;

          new Error(err);
        });
    },

    keymonitor(event) {
      // who caused it? "event.target.id"
      // console.log('keyup from id: ' + event.target.id);

      // what was pressed?
      let keyMessage = event.key || String.fromCharCode(event.keyCode);

      /* if (event.shiftKey) {
        keyMessage += 'Shift+';
      } */

      if (keyMessage == 'ArrowRight') {
        this.nextPage();
      }

      if (keyMessage == 'ArrowLeft') {
        this.previousPage();
      }
    },
    /* Pagination */
    nextPage() {
      if (this.currentPage >= 1 && this.currentPage < this.totalPages) {
        this.isLoading = true;
        this.currentPage++;

        this.retrieveLogs({
          page: this.currentPage,
          count: 10,
          record_filter: 'all_records',
          action_filter: this.action,
          search_word: this.searchWord,
          js_employer_id: this.$route.params.employer_id,
        })
          .then(res => {
            this.isLoading = false;
            this.totalPages = res.data.last_page;
          })
          .catch(err => {
            this.isLoading = false;

            new Error(err);
          });
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        --this.currentPage;
        this.isLoading = true;

        this.retrieveLogs({
          page: this.currentPage,
          count: 10,
          record_filter: 'all_records',
          action_filter: this.action,
          search_word: this.searchWord,
          js_employer_id: this.$route.params.employer_id,
        })
          .then(res => {
            this.isLoading = false;
            this.totalPages = res.data.last_page;
          })
          .catch(err => {
            this.isLoading = false;

            new Error(err);
          });
      } else {
        this.currentPage = 1;
      }
    },
    setToFirstPage() {
      this.currentPage = 1;

      this.retrieveLogs({
        page: this.currentPage,
        count: 10,
        record_filter: 'all_records',
        action_filter: this.action,
        search_word: this.searchWord,
        js_employer_id: this.$route.params.employer_id,
      })
        .then(res => {
          this.isLoading = false;
          this.totalPages = res.data.last_page;
        })
        .catch(err => {
          this.isLoading = false;

          new Error(err);
        });
    },
    setToLastPage(lastPage) {
      this.currentPage = lastPage;

      this.retrieveLogs({
        page: this.currentPage,
        count: 10,
        record_filter: 'all_records',
        action_filter: this.action,
        search_word: this.searchWord,
        js_employer_id: this.$route.params.employer_id,
      })
        .then(res => {
          this.isLoading = false;
          this.totalPages = res.data.last_page;
        })
        .catch(err => {
          this.isLoading = false;

          new Error(err);
        });
    },
    setPageBynumber(pageNumber) {
      if (pageNumber > this.getTotalPages || pageNumber < 1) return;
      this.currentPage = pageNumber;

      this.retrieveLogs({
        page: this.currentPage,
        count: 10,
        record_filter: 'all_records',
        action_filter: this.action,
        search_word: this.searchWord,
        js_employer_id: this.$route.params.employer_id,
      })
        .then(res => {
          this.isLoading = false;
          this.totalPages = res.data.last_page;
        })
        .catch(err => {
          this.isLoading = false;

          new Error(err);
        });
    },
  },
  computed: {
    ...mapGetters([
      'getEmployerLogs',
      'getUserProfile',
      'getEmployerUsers',
      'getLogActions',
      'getNextPage',
      'getLogs',
      'getAllCountries',
    ]),
  },
  mounted() {
    this.retrieveLogActions();

    this.retrieveLogs({
      page: 1,
      count: 10,
      record_filter: 'all_records',
      action_filter: this.action,
      search_word: this.searchWord,
      js_employer_id: this.$route.params.employer_id,
    })
      .then(res => {
        this.isLoading = false;
        this.totalPages = res.data.last_page;
      })
      .catch(err => {
        this.isLoading = false;

        new Error(err);
      });

    this.fetchTimezones(true);
    this.retrieveEmployerUsers({ js_employer_id: this.$route.params.employer_id });
    this.retrieveUserProfile().then(() => {
      this.timeZone = this.getUserProfile.timezone_data;
      this.selectedDateFormat = this.getUserProfile.format_date;
    });

    /* this.retrieveLogs({
      js_employer_id: this.$route.params.employer_id,
      page: this.currentPage,
      count: this.itemsPerPage,
      record_filter: 'all_records',
      action_filter: this.action,
    }); */
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.card {
  height: auto !important;
}
.controls-wrap {
  .scroller {
    height: 380px;
    overflow: hidden;
    overflow-y: auto;
    border-top: 1px solid #ddd;
    .custom-table {
      .log-id {
        padding-left: 20px;
      }
    }
  }
}

.fas:hover {
  cursor: pointer;
}

.jobs-controls {
  margin: 15px 5px 12px 5px;
  padding: 0 !important;
  .input-group {
    i {
      color: $color-table-location;
      position: absolute;
      pointer-events: none;
      top: 8px;
      right: 12px;
      font-size: 21px;
      z-index: 99;
    }
    .form-control {
      border-radius: 0.25rem !important;
    }
  }
}
</style>
